{
  "attachment_required_hint": "This request requires a supporting document. Attach a file before submitting.",
  "reject_code_attachment_required": "Attach a supporting document.",
  "attachment_required_title": "Require an attachment",
  "attachment_required_caption": "Require a supporting document when either threshold is exceeded. Leave a threshold empty to disable it, or enter 0 to always require a document.",
  "attachment_required_request_total": "Total per request, over ({units})",
  "attachment_required_cycle_total": "Total per cycle, over ({units})",
  "attachment_required_threshold_required": "Enter at least one attachment threshold",
  "attachment_required_threshold_range": "Enter a value from 0 to 999",
  "notice_period_calendar_days": "calendar days",
  "notice_period_working_days": "working days",
  "approval_policy_required": "Policy required",
  "policy_check_assigned": "Assigned",
  "policy_check_matched": "Policy with higher priority applied",
  "policy_check_not_effective": "Not in effect yet",
  "policy_check_pending": "Will apply after recalculation",
  "policy_check_not_matched": "Doesn't match",
  "policy_check_rules_count": "{count, plural, one {# rule} other {# rules}}",
  "policy_checks_title": "Why this policy",
  "policy_checks_no_policies": "The category has no policies",
  "policy_checks_none_matched": "The employee doesn't match any policy in the category",
  "policy_checks_open_category": "Open category",
  "policy_checks_title_none": "Why no policy",
  "policy_issues_found": "Policy issues found",
  "review_employees": "Review employees",
  "without_required_approval_only": "Without required approval policy",
  "without_required_approval_only_description": "Show only employees who require an approval policy but don't have one assigned",
  "policy_duplicate_caption": "The copy gets the same settings and current rules and is placed last in the category. It takes no employees until you move it up",
  "policy_duplicate_title": "Duplicate policy",
  "without_policy_only": "Without policy",
  "without_policy_only_description": "Show only employees who have no policy assigned in at least one category",
  "absence_type": "Absense type",
  "absence_type_sick_leave": "Sick leave",
  "absence_type_vacation": "Vacation",
  "accrual_action_accrual": "Accrual",
  "accrual_action_adjustment": "Balance adjustment",
  "accrual_action_balance_import": "Balance import",
  "accrual_action_booked": "Booked",
  "accrual_action_canceled": "Canceled",
  "accrual_action_carryover": "Carryover",
  "accrual_action_expire": "Expired",
  "accrual_action_expiration": "Expired",
  "accrual_action_initial_balance": "Initial balance",
  "accrual_action_used": "Used",
  "accrual_capped_note": "Maximum balance limit reached",
  "accrual_at_type_at_end_caption": "Example: July's leave {units} are added on July 31st, after the month is worked",
  "accrual_at_type_at_end_each": "end of each period",
  "accrual_at_type_at_end_title": "End of period",
  "accrual_at_type_at_start_caption": "Example: July's leave {units} are added on July 1st, allowing immediate use",
  "accrual_at_type_at_start_each": "start of each period",
  "accrual_at_type_at_start_title": "Start of period",
  "accrual_at_type_description": "Choose when employees receive their annual leave {units}",
  "accrual_at_type_title": "When leave {units} are added",
  "accrual_cap_title": "Maximum balance",
  "accrual_cap_yes_caption": "If not enabled, the balance will continue to grow indefinitely",
  "accrual_cap_yes_label": "Maximum balance, {units}",
  "accrual_cycles": "Accrual cycles",
  "accrual_cycles_caption": "Defines when a leave balance resets",
  "accrual_freq_biweekly": "every two weeks",
  "accrual_freq_daily": "every day",
  "accrual_freq_hire_date_monthly": "every month on the anniversary of their start date",
  "accrual_freq_hire_date_monthly_annual_proportional": "per year, accrued monthly on the anniversary of their start date",
  "accrual_freq_monthly": "every month",
  "accrual_freq_monthly_annual_proportional": "per year, accrued monthly",
  "accrual_freq_quarterly": "every quarter",
  "accrual_freq_semiannual": "twice a year",
  "accrual_freq_semimonthly": "twice a month",
  "accrual_freq_weekly": "every week",
  "accrual_freq_yearly": "every year",
  "accrual_freq_yearly_hire_date": "every year on the anniversary of their start date",
  "accrual_information": "{amount} accrued {period}",
  "accrual_summary_added_at_caption": "added at the",
  "accrual_summary_earn_caption": "Employees earn",
  "accrual_summary_plural_leave_days": "{count, plural, one {leave day} other {leave days}}",
  "accrual_summary_plural_leave_hours": "{count, plural, one {leave hour} other {leave hours}}",
  "accrue": "Accrue",
  "accrue_for": "Accrue for {period}",
  "accrue_settings": "Accrue settings",
  "accrued": "Accrued",
  "accrued_by_now": "Accrued by now in this period",
  "accrued_for": "Accrued for {period}",
  "accrued_total_in_period": "Total to be accrued in this period",
  "accrues_and_spendings": "Accrues & spendings for all time-off",
  "action": "Action",
  "add_milestone": "Add milestone",
  "add_note": "Add note",
  "add_note_description": "Leave some extra information about your leave, such as reason, if needed...",
  "adjustment_deleted": "Adjustment deleted",
  "all_balance_changes": "All balance changes",
  "all_timeoff": "All time off",
  "apply_changes": "Apply changes",
  "apply_to_all_workdays": "Apply to all workdays",
  "apply_to_all_workdays_caption": "Weekends will not be affected",
  "apply_changes_from_date": "Apply changes from {date}",
  "apply_to_current_rules": "Apply to current rules",
  "apply_to_current_rules_caption": "Effective from {date}",
  "affected_period": "Affected period {start} — {end}",
  "approved_timeoffs_may_exceed_caption": "Previously approved time-offs may cause balances to exceed policy limits",
  "balances_will_be_recalculated_count": "{count, plural, =0{No employee balances will be recalculated} one{# employee balance will be recalculated} other{# employee balances will be recalculated}}",
  "changes_will_take_effect_on": "Changes will take effect on {date}",
  "choose_effective_date_caption": "Choose effective date in future",
  "choose_effective_date_to_apply_changes": "Choose effective date to apply changes",
  "create_new_rules_from": "Create new rules from...",
  "effective_date": "Effective date",
  "employees_will_use_these_rules_count": "{count, plural, =0{No employees will use these rules} one{# employee will use these rules} other{# employees will use these rules}}",
  "existing_balances_will_stay_unchanged": "Existing balances will stay unchanged",
  "historical_balances_will_be_recalculated": "Historical balances will be recalculated",
  "i_understand_historical_changes": "I understand that historical balances & reports may change",
  "in_n_days": "{count, plural, =0{Today} one{In # day} other{In # days}}",
  "some_balances_may_become_negative": "Some balances may become negative",
  "will_affect_only_future_accruals": "Will affect only future accruals",
  "approval": "Approval",
  "approve_request_title": "Requests {request_days} of {category_title}",
  "available": "Available",
  "available_balance": "Available balance",
  "count_days_available": "{count_days} available",
  "count_days_requested": "{count_days} requested",
  "available_on_date": "Available on {date}: {balance}",
  "away_till": "Away till {date}",
  "available_balance_on_dates": "Available on the time-off start date ({date}): {balance}. Balance after the selected time off: {balance_forecast}",
  "available_today": "Available today",
  "awaiting_approval": "Awaiting approval {from_count}",
  "balance": "Balance",
  "balance_after": "Balance after",
  "balance_as_of": "Balance as of {date}",
  "booked": "Booked",
  "booked_time_off": "Booked {time_off_category}",
  "breakdown": "Breakdown",
  "carried_from_previous_period": "Carried over from previous period",
  "carryover": "Carryover",
  "carryover_date_hire_title": "Start date",
  "carryover_date_quarter_title": "First day of the quarter",
  "carryover_date_specific_title": "Specific date",
  "carryover_expiration": "Carryover expiration",
  "carryover_expiration_caption": "Expiration for carried over leave if it is allowed",
  "carryover_expiration_date_day_title": "Day",
  "carryover_expiration_date_month_title": "Month",
  "carryover_expiration_date_title": "Choose whether limit is counted in days or months",
  "carryover_expiration_date_week_title": "Week",
  "carryover_expiration_date_year_title": "Year",
  "carryover_expiration_no_caption": "Carried over {units} stay available until used",
  "carryover_expiration_no_title": "Keep extra {units} with no time limit",
  "carryover_expiration_yes_caption": "Carried over {units} must be used by your set deadline",
  "carryover_expiration_yes_title": "Set time limit for using extra {units}",
  "carryover_second_date_title": "Second date",
  "category": "Category",
  "category_delete_caption": "This will permanently delete the leave category and ALL related leave records. This action cannot be undone.",
  "category_delete_title": "Delete this category",
  "category_type_accrues_time_description": "Employees earn leave based on schedule or manual balance settings",
  "category_type_accrues_time_title": "Accrues time",
  "category_type_description": "Set if employees accumulate {units} over time or use them without balance",
  "category_type_flexible_description": "No balance tracking, but requests need approval and recording",
  "category_type_flexible_title": "Flexible (unlimited)",
  "category_type_manual_description": "Custom policy without automatic accrual for special cases",
  "category_type_manual_title": "Manual",
  "category_type_title": "Category type",
  "change_style": "Change style",
  "choose_category": "Choose category",
  "choose_period": "Choose period",
  "choose_period_from": "Choose period from",
  "choose_period_to": "Choose period to",
  "no_policy": "No policy",
  "policies_order_confirm_title": "Confirm the new order",
  "policies_order_hint": "Policies at the top have higher priority. An employee gets the policy with the highest priority whose rules they match",
  "policies_order_no_transitions": "No employees will move to another policy",
  "policies_order_unsaved_changes": "If you change the order now, unsaved changes on this page will be lost",
  "policies_manage_priority": "Manage priority",
  "policies_priority_caption": "Drag to change priority",
  "policies_priority_title": "Manage policy priority",
  "policies_order_review": "Review changes...",
  "policy_assign_taken_by_upper_count": "{count, plural, one{# of them already gets a policy with higher priority} other{# of them already get a policy with higher priority}}",
  "policy_fallback_caption": "Fallback: for everyone not covered by policies with higher priority",
  "policy_no_employees": "No employees",
  "policy_taken_by_upper_hint": "{count, plural, one{# employee matches this policy but gets a policy with higher priority} other{# employees match this policy but get a policy with higher priority}}",
  "policy_transition_count": "{count, plural, one{# employee will move from {from} to {to}} other{# employees will move from {from} to {to}}}",
  "configure_policies_title": "Configure policies",
  "configure_title": "Configure leave details",
  "contact_manager_to_check_approval_policy_settings": "Contact your manager to check approval policy settings",
  "count_days_types_calendar_days_description": "Count all days in absence period including weekends and holidays",
  "count_days_types_description": "Specify which days count towards the leave - all calendar days or working days only, affecting how weekends and holidays are calculated",
  "count_days_types_title": "Days to count",
  "count_days_types_working_days_description": "Count only business days, excluding weekends and holidays",
  "day_amount_type_description": "Choose how much one working day of a request costs when tracking in days",
  "day_amount_type_full_day_title": "Full day",
  "day_amount_type_full_day_description": "Any working day costs a whole day regardless of the work pattern",
  "day_amount_type_title": "Day cost",
  "day_amount_type_work_pattern_share_title": "By work pattern",
  "day_amount_type_work_pattern_share_description": "A day costs its share of the longest day in the work pattern — on an 8/8/8/8/4 pattern Friday deducts half a day",
  "fte_proration_title": "Accrue proportionally to FTE",
  "fte_proration_caption": "Part-time employees accrue in proportion to their FTE. Applies from this version's effective date and does not recalculate past accruals",
  "create_new": "Create new leave category",
  "create_new_policy_description": "Set up rules for leave calculation and usage",
  "create_new_policy_title": "Create new policy",
  "create_new_timeoff_request": "New request",
  "create_new_timeoff_request_description": "Create new request",
  "created": "Created",
  "custom_amount": "Custom amount",
  "custom_amount_caption": "And mass assignment",
  "customize_breakdown": "Customize breakdown",
  "day": "day",
  "days": "Days",
  "days_genitive": "Days",
  "days_prepositional": "Days",
  "decrease_balance": "Decrease balance",
  "delete_adjustment_confirm": "Do you want to delete this adjustment?",
  "delete_adjustment_confirm_description": "This action cannot be undone",
  "dont_forget": "Don’t forget",
  "earnings": "Earnings",
  "edit_balance": "Edit balance",
  "edit_policy_title": "Edit policy",
  "edit_timeoff": "Edit time-off",
  "edit_timeoff_request": "Edit leave",
  "edit_timeoff_request_description": "Edit your request",
  "edit_title": "Edit leave category",
  "employee_requests": "Requests",
  "enter_amount_in_units": "Enter amount in {units}",
  "expiration_date": "Expiration date",
  "full_day": "Full day",
  "half_day": "Half day",
  "history_of_category": "{category_name} history",
  "hour": "hour",
  "hours": "Hours",
  "hours_genitive": "Hours",
  "hours_prepositional": "Hours",
  "in_units": "in",
  "increase_balance": "Increase balance",
  "insufficient_units_for_request": "Insufficient {units} for request",
  "is_public_description": "Show this leave type in shared calendars and employee profiles",
  "is_public_title": "Public visible",
  "leave_earnings": "Leave earnings",
  "leave_type": "Leave type",
  "leave_type_description": "Specify whether this is regular leave or parental leave (maternity, paternity, childcare)",
  "leave_type_parental": "Parental leave",
  "leave_type_regular": "Regular leave",
  "leave_types": "Leave types",
  "limits_negative_balance_allowance_caption": "Allow employees to take more {units} than currently accrued",
  "limits_negative_balance_allowance_title": "Negative balance allowance",
  "max_amount": "Maximum amount",
  "milestone_accrual_date_type_biweekly": "Every 2 weeks",
  "milestone_accrual_date_type_daily": "Daily",
  "milestone_accrual_date_type_hire_date": "Annual start date",
  "milestone_accrual_date_type_hire_date_monthly": "Monthly on start date",
  "milestone_accrual_date_type_hire_date_monthly_annual_proportional": "Annual, accrued monthly on start date",
  "milestone_accrual_date_type_monthly": "Monthly",
  "milestone_accrual_date_type_monthly_annual_proportional": "Annual, accrued monthly",
  "milestone_accrual_date_type_quarterly": "Quarterly",
  "milestone_accrual_date_type_semiannual": "2 times in year",
  "milestone_accrual_date_type_semimonthly": "2 times in month",
  "milestone_accrual_date_type_weekly": "Weekly",
  "milestone_accrual_date_type_yearly": "Annually",
  "milestone_carryover_none_caption": "Unused leave expires at year end or anniversary - use it or lose it policy",
  "milestone_carryover_none_title": "No carryover",
  "milestone_carryover_settings_caption": "At the end of the cycle",
  "milestone_carryover_settings_description": "What happens to unused leave?",
  "milestone_carryover_unlimited_caption": "All unused leave carries over (subject to maximum balance limits)",
  "milestone_carryover_unlimited_title": "Keep all unused leave",
  "milestone_carryover_up_to_caption": "Keep up to a set amount of unused leave for next year",
  "milestone_carryover_up_to_title": "Limited carryover",
  "milestone_delete_caption": "If you delete this milestone accrues, made according with it, will not be affected",
  "milestone_delete_title": "Delete this milestone",
  "milestone_edit": "Edit milestone",
  "milestone_list_caption_on_date": "on {date}",
  "milestone_list_caption_on_day": "on the {day, selectordinal, one{#st} two{#nd} few{#rd} other{#th}} day",
  "milestone_list_caption_on_two_dates": "on {date1} and {date2}",
  "milestone_list_caption_on_two_days": "on the {day1, selectordinal, one{#st} two{#nd} few{#rd} other{#th}} and {day2, selectordinal, one{#st} two{#nd} few{#rd} other{#th}}",
  "milestone_list_title": "Starting from {amount, selectordinal, one{#st} two{#nd} few{#rd} other{#th}} {date_type, select, day{day} week{week} month{month} year{year} other{}}",
  "milestone_new": "New milestone",
  "milestone_start": "When it starts",
  "milestone_start_amount_title": "From start date",
  "milestone_start_balance_caption": "If not enabled, the initial balance will be set to 0",
  "milestone_start_balance_lable": "Balance at the start of milestone, {units}",
  "milestone_start_balance_title": "Starting balance",
  "milestone_start_description": "Choose when employees start earning their leave time",
  "milestone_start_text_from_hire_date": "from start date",
  "milestone_start_text_number": "number",
  "milestone_start_text_starts_in": "Milestone starts in",
  "milestone_starts_from_hire_date": "Count from start date",
  "milestone_starts_from_hire_date_caption": "Disable if you want to choose another period",
  "milestone_transfer_type_description": "Choose when to apply new milestone conditions for employees",
  "milestone_transfer_type_end_period_caption": "New conditions apply from next accrual period start",
  "milestone_transfer_type_end_period_title": "At the end of the accrual period",
  "milestone_transfer_type_immediately_caption": "New conditions apply right when employee reaches milestone",
  "milestone_transfer_type_immediately_title": "Immediately upon meeting condition",
  "milestone_transfer_type_title": "When milestone changes take effect",
  "milestones": "Milestones",
  "milestones_description": "Milestones allow to change accruement rules during time",
  "min_amount": "Minimum amount",
  "minimum_daily_amount_caption": "Set smallest allowed leave request (full {unit} or partial)",
  "minimum_daily_amount_title": "Minimum daily amount",
  "minimum_fraction_is": "Minimum fraction is",
  "modified": "Modified",
  "modified_breakdown": "Modified breakdown",
  "negative_balance_in_cycle_allowed_caption": "Allow negative balance only during the current accrual cycle",
  "negative_balance_in_cycle_allowed_title": "Negative balance only during cycle",
  "new_policy_title": "New policy",
  "no_requests_created": "No time-off requests created yet",
  "no_requests_created_description": "Here you will see all your time-off requests",
  "not_available": "Not available",
  "notice_period_caption": "Set how far in advance leave must be requested",
  "notice_period_title": "Minimum and maximum notice period",
  "notification_approval_request_title": "Created {category} request and waits for your approval",
  "notification_settings_time_off_caption": "When your approval is required or response to your request",
  "overlap_requests_allowed_caption": "Allow taking time off for dates that overlap with other requests",
  "overlap_requests_allowed_title": "Date overlaps",
  "paid_type_description": "Choose how salary is calculated during leave",
  "paid_type_not_working_paid_description": "Employee is off work but receives regular compensation (vacation, holidays)",
  "paid_type_not_working_paid_title": "Non-working, paid",
  "paid_type_not_working_unpaid_description": "Leave without pay (personal leave, sabbatical, unpaid vacation)",
  "paid_type_not_working_unpaid_title": "Non-working, unpaid",
  "paid_type_title": "Paid category",
  "paid_type_working_paid_description": "Employee receives regular pay during absence (sick leave, medical leave)",
  "paid_type_working_paid_title": "Working, paid",
  "past_requests_allowed_caption": "Allow taking time off for past dates",
  "past_requests_allowed_title": "Backdated time off",
  "period_track_type_title": "Time units",
  "policy_report": "Current policies",
  "probation_requests_restricted_caption": "Prevent taking time off while employee is on probation",
  "probation_requests_restricted_title": "Probation restriction",
  "reject_code_asked_date_from_less_then_min_notice_period": "The requested start date is earlier than the minimum notice period allows.",
  "reject_code_asked_date_from_less_then_today": "The requested start date is earlier than today.",
  "reject_code_asked_date_from_more_then_max_notice_period": "The requested start date is beyond the maximum notice period.",
  "reject_code_asked_less_then_min_daily_amount": "The requested amount is less than the minimum allowed daily amount.",
  "reject_code_asked_less_then_min_request_total": "The total requested amount is below the minimum allowed value.",
  "reject_code_asked_more_then_max_request_total": "The total requested amount exceeds the maximum allowed value.",
  "reject_code_cannot_create_overlapped_time_off_requests": "Cannot create time-off requests that overlap in time",
  "reject_code_cannot_create_time_off_requests_in_probation": "Time off is not available during probation",
  "reject_code_invalid_request": "The request is invalid. Please check the submitted data.",
  "reject_code_no_approval_policy": "No approval policy is associated with this request.",
  "reject_code_no_confirmation_employees": "There are no employees requiring confirmation for this action.",
  "reject_code_no_time_off_policy": "The selected leave category has no policy settings. Please contact the administrator",
  "reject_code_not_enough_days": "Insufficient days available to complete this request.",
  "reject_code_not_enough_hours": "Insufficient hours available to complete this request.",
  "reject_code_time_off_category_not_found": "The specified leave category could not be found.",
  "category_request": "{category} request",
  "request_amount_caption": "Set limits on duration of single leave request",
  "request_amount_title": "Minimum and maximum leave request amounts",
  "request_time_off": "Request {category_name}",
  "request_timeoff": "Request time off",
  "require_confirmation": "Require confirmation",
  "require_confirmation_description": "Set whether leave requests need approval before being finalized",
  "require_confirmation_no_caption": "No, confirmation is not required",
  "require_confirmation_no_description": "Requests are automatically approved when submitted",
  "require_confirmation_yes_caption": "Yes, confirmation required",
  "require_confirmation_yes_description": "Manager must approve each leave request",
  "save_final_approved_caption": "Your calendar has been updated and your team has been notified",
  "save_final_approved_title": "Time off approved!",
  "save_final_await_caption": "We've notified your approvers. You'll hear back as soon as they review it",
  "save_final_await_title": "Your request is on its way!",
  "see_requests": "See requests",
  "settings_description": "Set up vacation policies and tracking",
  "settings_title": "Time off",
  "spendings": "Spendings",
  "start_balance_type_description": "How much vacation time new employees get when they start",
  "start_balance_type_full_caption": "Employee gets all vacation {units} right away, no matter when they start",
  "start_balance_type_full_title": "Full accrual amount",
  "start_balance_type_proportional_caption": "{units_cap} are calculated based on when person starts. Example: 6 months left in year = half of vacation {units}",
  "start_balance_type_proportional_title": "Proportional accrual",
  "start_balance_type_title": "First accrual",
  "termination_accrual_type_title": "On termination",
  "termination_accrual_type_description": "What to accrue on the termination date for an incomplete period",
  "termination_accrual_type_proportional_title": "Proportional",
  "termination_accrual_type_proportional_caption": "A share for the worked part of the period is accrued",
  "termination_accrual_type_no_partial_title": "No accrual for an incomplete period",
  "termination_accrual_type_no_partial_caption": "Nothing is accrued for an incomplete period on the termination date",
  "time_off": "Time off",
  "time_off_calendar": "Leave timeline",
  "filter_employee_subordinates": "Employee's direct reports",
  "time_off_delete_title": "Delete this {time_off_type}",
  "time_off_description": "Manage employee vacation requests, sick leaves and approval processes",
  "time_off_history_for": "Time-off history for {employee}",
  "title": "Leave management",
  "total_units": "Total {units}",
  "used_amount": "Used amount",
  "transfer_unused_balance": "Transfer of unused balance to next period",
  "units_accrued": "<b>{units}</b> accrued",
  "units_to_accrue": "<b>{units}</b> to accrue",
  "units_booked": "<b>{units}</b> booked",
  "units_expired": "<b>{units}</b> expired",
  "units_to_expire": "<b>{units}</b> to expire",
  "units_spent": "<b>{units}</b> spent",
  "used": "Used",
  "used_time_off": "Used {time_off_category}",
  "before_date": "Before {date}",
  "changes_timeline": "Changes timeline",
  "current_rules": "Current rules",
  "current_rules_since": "Current rules since {date}",
  "change_effective_date": "Change effective date",
  "edit_rules": "Edit rules",
  "hide_changes": "Hide changes",
  "initial_rules": "Initial rules",
  "since_date": "Since {date}",
  "vacancies_sick": "Vacations, sick leaves & other",
  "view_all_history": "View all history",
  "view_breakdown": "View breakdown",
  "view_changes": "View changes",
  "~": "~",
  "action_tag_carryover": "Carried over",
  "action_tag_adjusted": "Adjusted",
  "action_tag_burned": "Burned",
  "adjusted_by": "Adjusted by {name}",
  "all_requests_history": "All time-off requests history",
  "balance_change": "Change"
}
